import React from 'react'
import {useIntl} from 'react-intl'
import {Button} from '../../../../_gori/partials/widgets'

type Props = {
  isVisible: boolean
  onDismiss: () => void
}

const BatchesWalkthrough: React.FC<Props> = ({isVisible, onDismiss}) => {
  const intl = useIntl()

  if (!isVisible) {
    return null
  }

  return (
    <div className='batches-walkthrough'>
      <div className='batches-walkthrough__card'>
        <div className='batches-walkthrough__image'>
          <img
            src='https://mcusercontent.com/e02bd0c93b1e69aaf4ce4a9b5/images/9cf9a57d-d289-19fc-bea5-30c7700ffe4a.gif'
            alt='walkthrough'
            className='w-100 d-block rounded-1'
          />
        </div>
        <div className='batches-walkthrough__content'>
          <h4 className='batches-walkthrough__title'>
            {intl.formatMessage({id: 'DROP_IT_ANYWHERE'})}
          </h4>
          <p className='batches-walkthrough__description'>
            {intl.formatMessage({id: 'BATCHES_WALKTHROUGH_DESCRIPTION'})}
          </p>
          <Button
            className='btn btn-sm btn-advanced-primary'
            label={intl.formatMessage({id: 'CLOSE'})}
            event={onDismiss}
          />
        </div>
      </div>
    </div>
  )
}

export {BatchesWalkthrough}
